import React from 'react';
import { connect } from 'react-redux';

import { signIn } from '../../actions/authAction';
import logoImg from '../../images/logo.png';
import FormInput from '../forms/FormInput';
import history from '../../history';
import { setName, setEmail, setRole, setAdmin, setApprover, setEditor, setBookGroup,setLoading } from '../../actions/authAction';
import api from '../../api/api';
import uri from '../../variables/uri';

class Login extends React.Component {
    state = {
        username: '',
        password: '',
        isDomain: true,
        isLoading: false,
        errorMsg: ''
    }

    componentDidMount = async () => {
        // if (localStorage.getItem('username') !== null && localStorage.getItem('password') !== null) {
        //     this.setState({ isLoading: true, username: localStorage.getItem('username'), password: localStorage.getItem('password') });
        //     api.getToken().then(response => {
        //         this.handleSignIn(response);
        //     }).catch(() => {
        //         this.setState({ isLoading: false, errorMsg: 'Invalid username or password' });
        //     });
        // }
    }

    handleSignIn = async (response) => {
        this.props.signIn();
        this.props.setEmail(response.data.mail);
        if(response.data.givenName != null){
            this.props.setName(`${response.data.givenName} ${response.data.sn}`);
        }else{
            this.props.setName(`${response.data.displayName}`);
        }
        
        try {
            const role = await api.get(`${uri.GET_ROLE}?userId=${response.data.sAMAcountName}`);
            this.props.setRole(role.data);
        } catch (ex) {

        }
        try {
            const permis = await api.get(`${uri.GET_PERMISSION}?userId=${response.data.sAMAcountName}`);
            if(permis.status === 200){
                this.props.setAdmin(permis.data.IsAdmin);
                this.props.setApprover(permis.data.IsApprover);
                this.props.setEditor(permis.data.IsEditor);
                this.props.setBookGroup(permis.data.BookGroups);
            }
        } catch (ex) {

        }
        history.push(`/home/${response.data.sAMAcountName}`);
        this.setState({ isLoading: false });
    }
    onUsernameChange = (username) => {
        this.setState({ username });
    }

    onPasswordChange = (password) => {
        this.setState({ password });
    }

    onSubmit = () => {
        localStorage.setItem('username', this.state.username);
        localStorage.setItem('password', this.state.password);
        this.setState({ isLoading: true });
        api.getToken().then(response => {
           this.handleSignIn(response);
        }).catch(() => {
            this.setState({ isLoading: false, errorMsg: 'Invalid username or password' });
            localStorage.removeItem('username');
            localStorage.removeItem('password');
        });
    }

    onClickMode =(m) => {
        if(m === "domain"){
            this.setState({isDomain: true});
            //https://ebillqas.scg.com/EBillAuthentication/Login/ExternalLogin?clientId=Doa
            //https://ebill.scg.com/EBillAuthentication/Login/ExternalLogin?clientId=DoaProd
            this.props.setLoading(true);
            window.location.replace('https://ebill.scg.com/EBillAuthentication/Login/ExternalLogin?clientId=DoaProd')
        }else{
            this.setState({isDomain: false});
        }
    }

    render() {
        return (
            <div className="main bg flex-v flex-1 pl-24 pr-24 pb-40" style={{ justifyContent: 'center' }}>
                <div className="flex-h" style={{ alignItems: 'center', marginLeft: 'auto', marginRight: 'auto' }}>
                    <img style={{ height: '50px' }} src={logoImg} alt="" />
                    <div className="subtitle is-4 ml-8"> | DOA</div>
                </div>
                <div className="mr-16 ml-16 mt-16 mb-8">
                    <div className="columns is-desktop">
                        <div className="column"></div>
                        <div className="column">
                            {/* <div className="subtitle is-6 ml-8">Welcome</div> */}
                            <button onClick={() => this.onClickMode('domain')} className={`button is-link is-fullwidth left`}>Login with Domain User</button>
                            <br></br>
                            <button onClick={() => this.onClickMode('local')} className={`button is-info is-fullwidth left`}>Login with Local Account</button>
                            {!this.state.isDomain &&
                                <div>
                                    <FormInput
                                        name="Username"
                                        value={this.state.username}
                                        onValueChange={this.onUsernameChange}
                                        type="text"
                                        suffix="@scg.com" />
                                    <FormInput
                                        name="Password"
                                        value={this.state.password}
                                        onValueChange={this.onPasswordChange}
                                        type="password" />
                                    <h3 className="has-text-danger mt-32 mb-8 has-text-centered">{this.state.errorMsg}</h3>
                                    <button disabled={this.state.username.length === 0 || this.state.password.length === 0} onClick={() => this.onSubmit()} className={`button is-success is-fullwidth ${this.state.isLoading && 'is-loading'}`}>Login</button>
                                </div>
                            }
                                </div>
                                <div className="column"></div>
                            </div>
                    
                </div>
            </div>
        );
    }
}

export default connect(null, {
    signIn,
    setEmail,
    setName,
    setRole,
    setAdmin,
    setApprover,
    setEditor,
    setBookGroup,
    setLoading
})(Login);